/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {useState, useEffect, useRef, useCallback} from 'react';
import {Document, Page, pdfjs} from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import ReactCrop, {centerCrop, makeAspectCrop} from 'react-image-crop';
import Pagination from '../components/Pagination';
import Delete from '../components/Delete';
import Util from '../util/Util';
import FileUtils from '../util/FileUtils';
import './Detail.scss';
import Analytics from '../util/Analytics';
import ReactImageScaler from '../components/ReactImageScaler';
import MarsUpload from '../components/MarsUpload';
import 'react-image-crop/dist/ReactCrop.css';
import Badge from '../components/Badge';
import DeleteTag from '../components/DeleteTag';
import AddTag from '../components/AddTag';
import Locale from '../util/Locale';
import {ReactComponent as FourOneRatio} from '../images/4_1_ratio_icon.svg';
import {ReactComponent as FourThreeRatio} from '../images/4_3_ratio_icon.svg';
import {ReactComponent as TenOneRatio} from '../images/10_1_ratio_icon.svg';
import {ReactComponent as NineSixteenRatio} from '../images/9_16_ratio_icon.svg';
import {ReactComponent as CustomRatio} from '../images/custom_icon.svg';
import ImageRotate from '../components/ImageRotate';
import ImageBrightnessAndContrast from '../components/ImageBrightnessAndContrast';

// Use an absolute CDN URL so the worker resolves correctly when the app is
// embedded cross-origin (e.g. as a widget script where the base URL is about:blank).
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function Detail({
    focused,
    tags = [],
    setShowModal = () => {},
    onAddTag = () => {},
    setShowFocused = () => {},
    getSelectedPathForUploads = () => {},
    controllerApi,
    previousEnabled,
    nextEnabled,
    onPreviousAsset = null,
    onNextAsset = null,
    onDeleteTag,
    onDeleteAssetList = null,
    onAction,
    checkForPrevAndNext,
    page,
    maxPages,
    updateStatePrevAndNext,
    viewData,
    getLocked = () => false,
    renderLoadingIcon,
    cropping = false,
    resizing = false,
    rotating = false
}) {
    const previewElement = useRef();
    const videoElement = useRef();
    const tagsElement = useRef();
    const previousUrl = useRef(focused?.name);
    const doubleClickTimerId = useRef(null);

    const [pdfPage, setPdfPage] = useState(1);
    const [pdfPages, setPdfPages] = useState(1);
    const [loadingPDF, setLoadingPDF] = useState(true);
    const [isResizing, setIsResizing] = useState(resizing);
    const [resizeWidth, setResizeWidth] = useState(0);
    const [resizeHeight, setResizeHeight] = useState(0);
    const [isCropping, setIsCropping] = useState(cropping);
    const [isRotating, setIsRotating] = useState(rotating);
    const [isAdjusting, setIsAdjusting] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [playerTopMargin, setPlayerTopMargin] = useState(0);
    const [cropImage, setCropImage] = useState(null);
    const [crop, setCrop] = useState({
        unit: '%',
        width: 50,
        height: 50,
        x: 25,
        y: 25
    });
    const [imageDimensions, setImageDimensions] = useState({
        width: 0,
        height: 0
    });
    const [isShowingAddTagModal, setIsShowingAddTagModal] = useState(false);
    const [cropRatio, setCropRatio] = useState(null);

    const resizingOrCropping = useCallback(() => {
        return isResizing || isCropping || isRotating || isAdjusting;
    }, [isResizing, isCropping, isRotating, isAdjusting]);

    const onKeyHandler = useCallback(
        event => {
            let shouldTrack = false;
            // other modalities are handled in MediaLibraryController.onNext/PrevAsset checking for shwModal but
            // resizing and cropping are local to Detail
            const resizingCropping = resizingOrCropping();

            if (event.key === 'ArrowLeft' && previousEnabled && !resizingCropping) {
                shouldTrack = onPreviousAsset(focused?.index);
            } else if (event.key === 'ArrowRight' && nextEnabled && !resizingCropping) {
                shouldTrack = onNextAsset(focused?.index);
            }
            if (shouldTrack) {
                Analytics.trackEvent('Detail View Change', `${event.key} key`);
            }
        },
        [focused?.index, nextEnabled, onNextAsset, onPreviousAsset, previousEnabled, resizingOrCropping]
    );

    const onDeleteTagHandler = useCallback(
        tagIdx => {
            return async () => {
                if (onDeleteTag) {
                    await onDeleteTag(tagIdx);
                }
            };
        },
        [onDeleteTag]
    );

    const showAddTagModal = useCallback(() => {
        setShowModal({
            content: (
                <AddTag
                    tags={tags}
                    setShowModal={() => {
                        setIsShowingAddTagModal(false);
                        setShowModal(false);
                    }}
                    onAdd={onAddTag}
                    onDeleteHandler={onDeleteTagHandler}
                />
            )
        });
    }, [onAddTag, onDeleteTagHandler, setShowModal, tags]);

    useEffect(() => {
        document.addEventListener('keydown', onKeyHandler);

        return () => {
            document.removeEventListener('keydown', onKeyHandler);
        };
    }, [onKeyHandler]);

    useEffect(() => {
        if (focused && focused.mimeType === 'video' && !focused.status) {
            setPlayerTopMargin((previewElement.current.clientHeight - videoElement.current.clientHeight) / 2);
        }

        if (focused && Util.isImageFile(focused.name)) {
            setResizeWidth(previewElement.current.clientWidth);
            setResizeHeight(previewElement.current.clientHeight);
        }
    }, [focused, nextEnabled, previousEnabled, isCropping]);

    useEffect(() => {
        const tagCount = tags ? tags.length : 0;
        const tagElementsCount = tagsElement?.current?.childNodes.length;
        if (Util.isMobile() || tagCount === tagElementsCount) {
            if (isShowingAddTagModal) {
                showAddTagModal();
            }
        }

        if (focused) {
            if (previousUrl.current === focused.name) {
                return;
            }

            if (videoElement.current) {
                videoElement.current.load();
            }
            previousUrl.current = focused.name;
        }
    }, [isShowingAddTagModal, tags, focused]); // eslint-disable-line react-hooks/exhaustive-deps
    // }, [isShowingAddTagModal, showAddTagModal, tags, focused]);

    const onDeleteAsset = () => {
        if (onDeleteAssetList) {
            Analytics.trackEvent('Asset', 'Delete (Modal)');
            setShowModal({
                content: (
                    <Delete
                        title={Locale.getText('DELETE_FILE')}
                        list={[focused]}
                        setShowModal={setShowModal}
                        setShowFocused={setShowFocused}
                        onAction={onDeleteAssetList}
                    />
                ),
                width: 60
            });
        }
    };

    const getFileDetails = file => {
        if (file.width && file.height) {
            return (
                <span className="asset-dimensions file-type-dot">
                    {file.width} x {file.height}
                </span>
            );
        }
        return null;
    };

    const getPdfScale = () => {
        if (window.innerWidth < 1300) {
            return 1;
        }
        if (window.innerWidth < 1700) {
            return 1.5;
        }
        return 2;
    };

    const renderVideoProccessing = () => {
        return (
            <div className="video-processing">
                <div className="processing-message">
                    <img src={Util.getPlaceholderByType(Util.FILE_TYPE.VIDEOPROCESSING)} alt="Thumbnail" />
                    <div className="message-text">{Locale.getText('VIDEO_PROCESSING_MESSAGE')}</div>
                </div>
            </div>
        );
    };

    const getCropDimensions = () => {
        const converted = Util.convertPercentToPixel(
            imageDimensions.width,
            imageDimensions.height,
            crop.width,
            crop.height
        );
        return `${Math.round(converted.width)} x ${Math.round(converted.height)}`;
    };

    const openResizeTool = () => {
        setIsResizing(true);
        setIsCropping(false);
        setIsRotating(false);
        setIsAdjusting(false);
    };

    const openCroppingTool = () => {
        setIsResizing(false);
        setIsCropping(true);
        setIsRotating(false);
        setIsAdjusting(false);
    };

    const openRotateTool = () => {
        setIsResizing(false);
        setIsCropping(false);
        setIsRotating(true);
        setIsAdjusting(false);
    };

    const openContrastAndBrightnessTool = () => {
        setIsResizing(false);
        setIsCropping(false);
        setIsRotating(false);
        setIsAdjusting(true);
    };

    // The elements don't get updated while the add tags modal is up, don't know why, but we do have the actual (updated)
    // count of tags, so cheat a bit and use that number when it varies from number of actual elements
    //
    const invisibleTags = actualTagCount => {
        const tagsContainer = tagsElement.current;
        const elements = tagsContainer.childNodes;
        const WIDTH_LIMIT = tagsContainer.getBoundingClientRect().width;
        const SPACING = elements.length ? elements[0].offsetLeft - tagsContainer.offsetLeft : 0;
        let tagWidth = 0;
        for (let i = 0; i < elements.length; i += 1) {
            const {width} = elements[i].getBoundingClientRect();
            tagWidth += width + 2 * SPACING;
            if (tagWidth >= WIDTH_LIMIT) {
                return actualTagCount > elements.length
                    ? elements.length - i + actualTagCount - elements.length
                    : elements.length - i;
            }
        }
        return 0;
    };

    const createSelectionEvent = () => {
        const {id, name, height, width, label, altText} = focused;
        const mockEvent = {
            target: {
                id,
                name,
                height,
                width,
                label,
                altText
            },
            doubleClick: true,
            isDetails: true
        };
        onAction(mockEvent);
    };

    const handleDoubleClicks = event => {
        if (onAction) {
            if (doubleClickTimerId.current !== null) {
                clearTimeout(doubleClickTimerId.current);
                doubleClickTimerId.current = null;
            }
            if (event.detail === 1) {
                if (event.persist) {
                    event.persist();
                }
                doubleClickTimerId.current = setTimeout(() => onAction(event), 350);
            } else if (event.detail === 2) {
                createSelectionEvent();
            }
        }
    };

    const doTagsOverflow = () => {
        return (
            tagsElement.current &&
            (tagsElement.current.clientWidth < tagsElement.current.scrollWidth ||
                tagsElement.current.clientHeight < tagsElement.current.scrollHeight)
        );
    };

    const checkAndUpdatePrevAndNext = () => {
        const {prev, next} = checkForPrevAndNext(focused.id, viewData, page, maxPages, focused.index);
        updateStatePrevAndNext(prev, next);
    };

    const renderCropRatios = () => {
        return (
            <div className="crop-ratios">
                <nsemble-button
                    onClick={() => {
                        setCropRatio(null);
                    }}
                    text
                    class="ratio-button"
                >
                    <CustomRatio />
                    <span>{Locale.getText('CUSTOM')}</span>
                </nsemble-button>
                <nsemble-button
                    onClick={() => {
                        const cropped = centerCrop(
                            makeAspectCrop(
                                {
                                    unit: '%',
                                    width: 100
                                },
                                4 / 1,
                                imageDimensions.width,
                                imageDimensions.height
                            ),
                            imageDimensions.width,
                            imageDimensions.height
                        );
                        setCropRatio(4 / 1);
                        setCrop(cropped);
                    }}
                    text
                    class="ratio-button"
                >
                    <FourOneRatio />
                    <span>4:1</span>
                </nsemble-button>
                <nsemble-button
                    onClick={() => {
                        const cropped = centerCrop(
                            makeAspectCrop(
                                {
                                    unit: '%',
                                    height: 100
                                },
                                4 / 3,
                                imageDimensions.width,
                                imageDimensions.height
                            ),
                            imageDimensions.width,
                            imageDimensions.height
                        );
                        setCropRatio(4 / 3);
                        setCrop(cropped);
                    }}
                    text
                    class="ratio-button"
                >
                    <FourThreeRatio />
                    <span>4:3</span>
                </nsemble-button>
                <nsemble-button
                    onClick={() => {
                        const cropped = centerCrop(
                            makeAspectCrop(
                                {
                                    unit: '%',
                                    width: 100
                                },
                                10 / 1,
                                imageDimensions.width,
                                imageDimensions.height
                            ),
                            imageDimensions.width,
                            imageDimensions.height
                        );
                        setCropRatio(10 / 1);
                        setCrop(cropped);
                    }}
                    text
                    class="ratio-button"
                >
                    <TenOneRatio />
                    <span>10:1</span>
                </nsemble-button>
                <nsemble-button
                    onClick={() => {
                        const cropped = centerCrop(
                            makeAspectCrop(
                                {
                                    unit: '%',
                                    width: 100
                                },
                                9 / 16,
                                imageDimensions.width,
                                imageDimensions.height
                            ),
                            imageDimensions.width,
                            imageDimensions.height
                        );
                        setCropRatio(9 / 16);
                        setCrop(cropped);
                    }}
                    text
                    class="ratio-button portrait"
                >
                    <NineSixteenRatio />
                    <span>9:16</span>
                </nsemble-button>
            </div>
        );
    };

    const renderRotatingTool = () => {
        return (
            <ImageRotate
                setIsRotating={setIsRotating}
                src={focused.name}
                onApply={({image, width, height, flipped}) => {
                    const file = FileUtils.base64ToFile(
                        image,
                        Util.suggestedFilename(Util.decodeLabel(focused.label), width, height, flipped)
                    );
                    setShowModal({
                        content: (
                            <MarsUpload
                                dropFiles={[file]}
                                title={Locale.getText('UPLOAD')}
                                setShowUpload={setShowModal}
                                getSelectedPathForUploads={getSelectedPathForUploads}
                                advertising={controllerApi.isAdvertisingRoot()}
                                setShowFocused={setShowFocused}
                                hideDetailView
                            />
                        )
                    });
                }}
            />
        );
    };

    const renderContrastAndBrightnessTool = () => {
        const handleApply = ({image, contrast, brightness}) => {
            const decodedLabel = Util.decodeLabel(focused.label);
            const lastDotIndex = decodedLabel.lastIndexOf('.');
            const baseName = lastDotIndex > 0 ? decodedLabel.substring(0, lastDotIndex) : decodedLabel;
            const extension = lastDotIndex > 0 ? decodedLabel.substring(lastDotIndex) : '';
            const newFileName = `${baseName}-Bright-${brightness}-Con-${contrast}${extension}`;

            const file = FileUtils.base64ToFile(image, newFileName);
            setShowModal({
                content: (
                    <MarsUpload
                        dropFiles={[file]}
                        title={Locale.getText('UPLOAD')}
                        setShowUpload={setShowModal}
                        getSelectedPathForUploads={getSelectedPathForUploads}
                        advertising={controllerApi.isAdvertisingRoot()}
                        setShowFocused={setShowFocused}
                        hideDetailView
                    />
                )
            });
        };

        const handleCancel = () => {
            setIsAdjusting(false);
        };

        return (
            <div className="asset-adjustment">
                <ImageBrightnessAndContrast src={focused.name} onApply={handleApply} onCancel={handleCancel} />
            </div>
        );
    };

    const renderResizeTool = () => {
        return (
            <div className="asset-resize">
                <ReactImageScaler
                    src={focused.name}
                    maxScale={1}
                    scaleStep={0.1}
                    // eslint-disable-next-line react/jsx-boolean-value
                    displayResolution={true}
                    cancelLabel={Locale.getText('CANCEL')}
                    resizeLabel={Locale.getText('RESIZE')}
                    scaleLabel={Locale.getText('SCALE')}
                    imageSourceText={Locale.getText('NO_IMAGE_SOURCE')}
                    onCancel={() => {
                        setIsResizing(false);
                    }}
                    onScaleApply={({image, width, height}) => {
                        const file = FileUtils.base64ToFile(
                            image,
                            Util.suggestedFilename(Util.decodeLabel(focused.label), width, height)
                        );
                        setShowModal({
                            content: (
                                <MarsUpload
                                    dropFiles={[file]}
                                    title={Locale.getText('UPLOAD')}
                                    setShowUpload={setShowModal}
                                    getSelectedPathForUploads={getSelectedPathForUploads}
                                    advertising={controllerApi.isAdvertisingRoot()}
                                    setShowFocused={setShowFocused}
                                    hideDetailView
                                />
                            )
                        });
                    }}
                    width={resizeWidth}
                    height={resizeHeight}
                    backgroundColor="#f8f8f8"
                />
            </div>
        );
    };

    const renderPdfPagination = () => {
        if (focused && focused.mimeType === 'application/pdf') {
            return (
                <Pagination
                    condensed
                    totalAssets={pdfPages}
                    maxPages={pdfPages}
                    page={pdfPage}
                    setPage={pageNumber => {
                        setPdfPage(pageNumber + 1);
                    }}
                />
            );
        }
        return null;
    };

    const renderBottomPanel = () => {
        const fileType = Util.getFileTypeLabelFromMimeType(focused.mimeType, focused, true);
        const isResizable = getLocked && !getLocked() && fileType === Util.FILE_TYPE.IMAGE;
        const isCroppable = getLocked && !getLocked() && fileType === Util.FILE_TYPE.IMAGE;
        const isRotatable = getLocked && !getLocked() && fileType === Util.FILE_TYPE.IMAGE;
        const isAdjustable = getLocked && !getLocked() && fileType === Util.FILE_TYPE.IMAGE;
        const imageType = focused.name ? focused.name.substr(focused.name.lastIndexOf('.')).toLowerCase() : '';
        const isResizeDisabled = isResizable && imageType === '.gif';
        return (
            <div className="details-bottom-panel">
                {(Util.isMobile() || Util.isWidget()) && renderPdfPagination()}
                <div className="bottom-panel-container">
                    <div className="details-third">
                        <div className="detail-left-action-buttons">
                            {onDeleteAssetList && (
                                <nsemble-button
                                    destructive-text
                                    onClick={onDeleteAsset}
                                    title={Locale.getText('DELETE_ASSETS')}
                                >
                                    {Util.getDeleteIcon('#CC4331')}
                                </nsemble-button>
                            )}
                            <div className={`${!isResizable ? 'non-usable-button' : ''} resize-button-holder`}>
                                <nsemble-button
                                    text
                                    onClick={openResizeTool}
                                    title={Locale.getText('SCALE_ASSET')}
                                    disabled={isResizeDisabled ? true : undefined}
                                >
                                    {Util.getResizeIcon()}
                                </nsemble-button>
                                <div
                                    className="resizer-disabled-tooltip"
                                    // eslint-disable-next-line react/no-unknown-property
                                    disabledtext={Locale.getText('RESIZE_UNSUPPORTED')}
                                />
                            </div>
                            <div className={`${!isCroppable ? 'non-usable-button' : ''} crop-button-holder`}>
                                <nsemble-button text onClick={openCroppingTool} title={Locale.getText('CROP')}>
                                    {Util.getCropIcon()}
                                </nsemble-button>
                            </div>
                            <div className={`${!isRotatable ? 'non-usable-button' : ''} rotate-button-holder`}>
                                <nsemble-button text onClick={openRotateTool} title={Locale.getText('ROTATE')}>
                                    {/* {Util.getRotateIcon()} */}
                                    <svg
                                        fill="none"
                                        height="24"
                                        stroke="#00528A"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                                    </svg>
                                </nsemble-button>
                            </div>
                            <div className={`${!isAdjustable ? 'non-usable-button' : ''} adjust-button-holder`}>
                                <nsemble-button
                                    text
                                    onClick={openContrastAndBrightnessTool}
                                    title={Locale.getText('ML3_BRIGHTNESS_AND_CONTRAST')}
                                >
                                    <svg
                                        fill="none"
                                        height="24"
                                        stroke="#00528A"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle cx="12" cy="12" r="5" />
                                        <path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72 1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
                                    </svg>
                                </nsemble-button>
                            </div>
                            {Util.isWidget() && (
                                <div className="widget-insert-button">
                                    <nsemble-button
                                        text
                                        onClick={createSelectionEvent}
                                        title={Locale.getText('INSERT')}
                                    >
                                        {Util.getInsertIcon()}
                                    </nsemble-button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="center-details">
                        {!Util.isMobile() && !Util.isWidget() && renderPdfPagination()}
                        <div className="bottom-asset-details">
                            <span className="asset-type file-type-dot">
                                {fileType === Util.FILE_TYPE.VIDEOPROCESSING ? Util.FILE_TYPE.VIDEO : fileType}
                            </span>
                            {getFileDetails(focused)}
                            <span className="asset-file-size">{Util.byteSizeString(focused.fileSize, 1)}</span>
                        </div>
                    </div>
                    <div className="details-third">
                        <div className="prev-next-container">
                            <div className="prev-button-holder">
                                <nsemble-button
                                    onClick={() => {
                                        Analytics.trackEvent('Detail View Change', 'Previous Button');
                                        if (onPreviousAsset) {
                                            onPreviousAsset(focused?.index);
                                        }
                                    }}
                                    title={Locale.getText('ML3_PREVIOUS_ARROW')}
                                    disabled={previousEnabled ? undefined : true}
                                >
                                    {Locale.getText('ML3_PREV')}
                                </nsemble-button>
                            </div>
                            <div className="next-button-holder">
                                <nsemble-button
                                    onClick={() => {
                                        Analytics.trackEvent('Detail View Change', 'Next Button');
                                        if (onNextAsset) {
                                            onNextAsset(focused?.index);
                                        }
                                    }}
                                    title={Locale.getText('ML3_NEXT_ARROW')}
                                    disabled={nextEnabled ? undefined : true}
                                >
                                    {Locale.getText('ML3_NEXT')}
                                </nsemble-button>
                            </div>
                        </div>
                        <div className="bottom-asset-close">
                            <nsemble-button
                                text
                                onClick={() => {
                                    if (setShowFocused && setShowFocused(null)) {
                                        updateStatePrevAndNext(false, false);
                                    }
                                }}
                            >
                                <svg
                                    fill="none"
                                    height="24"
                                    stroke="#00528A"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <line x1="18" x2="6" y1="6" y2="18" />
                                    <line x1="6" x2="18" y1="6" y2="18" />
                                </svg>
                                <span>{Locale.getText('CLOSE')}</span>
                            </nsemble-button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderCurrentTags = () => {
        const tagCount = tags && tags?.length ? tags.length : 0;
        return (
            <div className="asset-tags">
                {!Util.isMobile() && (
                    <div className="tag-list" ref={tagsElement}>
                        {tags &&
                            tags.map((tag_, idx) => {
                                let tag = tag_;
                                if (typeof tag_ !== 'string') {
                                    tag = tag_.name;
                                }
                                return (
                                    <Badge
                                        text={Locale.getText(tag)}
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={`${tag}${idx}`}
                                        onCloseOverIcon={() => {
                                            setShowModal({
                                                content: (
                                                    <DeleteTag
                                                        tag={tag}
                                                        setShowModal={setShowModal}
                                                        onDelete={onDeleteTagHandler(idx)}
                                                    />
                                                )
                                            });
                                        }}
                                    />
                                );
                            })}
                    </div>
                )}
                {!Util.isMobile() && doTagsOverflow() && (
                    <nsemble-button
                        text
                        class="additional-tags"
                        onClick={() => {
                            showAddTagModal();
                            setIsShowingAddTagModal(true);
                        }}
                    >
                        {Locale.getText('MORE_TAGS', {count: invisibleTags()})}
                    </nsemble-button>
                )}
                {Util.isMobile() && Boolean(tagCount) && (
                    <nsemble-button
                        text
                        class="additional-tags"
                        onClick={() => {
                            showAddTagModal();
                            setIsShowingAddTagModal(true);
                        }}
                    >
                        {Locale.getText('VIEW_TAGS', {count: tagCount})}
                    </nsemble-button>
                )}
                <nsemble-button
                    text
                    onClick={() => {
                        showAddTagModal();
                        setIsShowingAddTagModal(true);
                    }}
                >
                    {Locale.getText('ADD_TAG')}
                </nsemble-button>
            </div>
        );
    };

    const renderVideoPlayer = () => {
        const videoSource = Util.getVideoAssetLink(focused.name);
        return (
            <div className="video-preview">
                <video controls ref={videoElement} onLoadedData={checkAndUpdatePrevAndNext}>
                    <source src={videoSource} type="video/mp4" />
                    <track default kind="captions" />
                </video>
            </div>
        );
    };

    const renderPdfViewer = () => {
        const onMobile = Util.isMobile() ? {width: 480} : {};
        return (
            <>
                {loadingPDF && renderLoadingIcon()}
                <div className="pdf-preview">
                    <Document
                        file={focused.name}
                        onLoadSuccess={({numPages}) => {
                            setLoadingPDF(false);
                            setPdfPages(numPages);
                            checkAndUpdatePrevAndNext();
                        }}
                        onLoadError={error => {
                            setLoadingPDF(false);
                            // eslint-disable-next-line no-console
                            console.error('[react-pdf] Failed to load PDF:', focused.name, error);
                        }}
                    >
                        <Page pageNumber={pdfPage} scale={getPdfScale()} width={onMobile?.width} />
                    </Document>
                </div>
            </>
        );
    };

    const renderImagePreview = () => {
        const modernBrowser = 'objectFit' in document.documentElement.style !== false;
        if (modernBrowser) {
            const placeholder =
                'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48ZyBzdHJva2VMaW5lY2FwPSJyb3VuZCIgc3Ryb2tlTGluZWpvaW49InJvdW5kIiBzdHJva2VXaWR0aD0iMiIgZmlsbD0iI0ZGRkZGRiIgc3Ryb2tlPSIjRkZGRkZGIj48cG9seWxpbmUgZGF0YS1jYXA9ImJ1dHQiIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZU1pdGVybGltaXQ9IjEwIiBwb2ludHM9IjEsMTcgNiwxMyAxMSwxNyAxNywxMCAyMywxNSAiLz4gPHJlY3QgeD0iMSIgeT0iMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2VNaXRlcmxpbWl0PSIxMCIgd2lkdGg9IjIyIiBoZWlnaHQ9IjIwIi8+IDxjaXJjbGUgZGF0YS1jb2xvcj0iY29sb3ItMiIgZmlsbD0ibm9uZSIgc3Ryb2tlTWl0ZXJsaW1pdD0iMTAiIGN4PSIxMCIgY3k9IjgiIHI9IjIiLz48L2c+PC9zdmc+';
            return (
                <div className="asset-preview">
                    <img
                        onClick={Util.isWidget() ? handleDoubleClicks : null}
                        src={focused.name}
                        alt={focused.name}
                        onError={e => {
                            e.target.onerror = null;
                            e.target.src = placeholder;
                            checkAndUpdatePrevAndNext();
                        }}
                        onLoad={checkAndUpdatePrevAndNext}
                    />
                </div>
            );
        }
        return (
            <div
                className="asset-preview"
                onClick={Util.isWidget() ? handleDoubleClicks : null}
                style={{
                    backgroundImage: `url('${focused.name}')`
                }}
            />
        );
    };

    const renderCroppingTool = () => {
        return (
            <div className="asset-crop">
                <div className="crop-tool">
                    <ReactCrop
                        imageStyle={{
                            maxWidth: resizeWidth,
                            maxHeight: resizeHeight * 0.9
                        }}
                        // eslint-disable-next-line react/jsx-curly-brace-presence
                        crossorigin={'true'}
                        crop={crop}
                        aspect={cropRatio}
                        onChange={(cropped, percentCrop) => {
                            setCrop(percentCrop);
                        }}
                    >
                        <img
                            alt="crop"
                            crossOrigin="true"
                            onLoad={e => {
                                const {naturalWidth: width, naturalHeight: height} = e.target;
                                setCropImage(e.target);
                                setImageDimensions({
                                    width,
                                    height
                                });
                            }}
                            src={focused.name}
                        />
                    </ReactCrop>
                </div>
                <div className="control-segment">
                    <div className="dimensions">
                        <span className="asset-dimensions">{getCropDimensions()}</span>
                    </div>
                    {renderCropRatios()}
                    <div className="crop-actions">
                        <nsemble-button
                            text
                            onClick={() => {
                                setIsCropping(false);
                                setCrop({
                                    unit: '%',
                                    width: 50,
                                    height: 50,
                                    x: 25,
                                    y: 25
                                });
                            }}
                        >
                            {Locale.getText('CANCEL')}
                        </nsemble-button>
                        <nsemble-button
                            text
                            onClick={() => {
                                const croppedFile = FileUtils.getCroppedImg(
                                    cropImage,
                                    {
                                        width: crop.width,
                                        height: crop.height,
                                        x: crop.x,
                                        y: crop.y
                                    },
                                    Util.decodeLabel(focused.label),
                                    cropRatio
                                );
                                Analytics.trackEvent('Image Edit', 'Crop', 0, 'Image Cropped');
                                setShowModal({
                                    content: (
                                        <MarsUpload
                                            dropFiles={[croppedFile]}
                                            title={Locale.getText('UPLOAD')}
                                            setShowUpload={setShowModal}
                                            getSelectedPathForUploads={getSelectedPathForUploads}
                                            advertising={controllerApi.isAdvertisingRoot()}
                                            setShowFocused={setShowFocused}
                                            // eslint-disable-next-line react/jsx-boolean-value
                                            hideDetailView={true}
                                        />
                                    )
                                });
                            }}
                        >
                            {Locale.getText('CROP')}
                        </nsemble-button>
                    </div>
                </div>
            </div>
        );
    };

    const renderPreview = () => {
        if (focused) {
            const fileType = Util.getFileTypeLabelFromMimeType(focused.mimeType, focused);
            if (fileType === Util.FILE_TYPE.PDF) {
                return renderPdfViewer();
            }
            if (fileType === Util.FILE_TYPE.VIDEO) {
                return renderVideoPlayer();
            }
            if (fileType === Util.FILE_TYPE.VIDEOPROCESSING) {
                return renderVideoProccessing();
            }
            if (fileType === Util.FILE_TYPE.IMAGE) {
                return renderImagePreview();
            }
        }
        return <div className="no-preview-available">{Locale.getText('NO_PREVIEW')}</div>;
    };

    const getEditTool = () => {
        if (isResizing) {
            return renderResizeTool();
        }
        if (isCropping) {
            return renderCroppingTool();
        }
        if (isRotating) {
            return renderRotatingTool();
        }
        if (isAdjusting) {
            return renderContrastAndBrightnessTool();
        }
        return null;
    };

    return (
        <div className="asset-details" ref={previewElement}>
            {renderCurrentTags()}
            {isResizing || isCropping || isRotating || isAdjusting ? getEditTool() : renderPreview()}
            {focused && !isResizing && !isCropping && !isRotating && !isAdjusting && renderBottomPanel()}
        </div>
    );
}

export default Detail;
